import { Default } from './switch.default'
import { Props } from './types'

const Switch = (props: Props) => <Default {...props} />

Switch.Default = Default

export default Switch
